import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserPlus, UserCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const FollowAccountButton = ({ handle, name, onChange }) => {
  const { t } = useI18n();
  const [st, setSt] = useState(null);
  const [hover, setHover] = useState(false);
  useEffect(() => { api.get(`/u/${handle}/follow-account`).then((r) => setSt(r.data)).catch(() => setSt(null)); }, [handle]);
  if (!st) return null;
  if (st.self) return <span className="text-xs text-slate-500 self-center" data-testid="follow-account-self">{t("fw.self")}</span>;
  const toggle = async () => {
    try {
      const r = st.following ? await api.delete(`/u/${handle}/follow-account`) : await api.post(`/u/${handle}/follow-account`);
      setSt({ ...st, following: r.data.following });
      toast.success(t(r.data.following ? "fw.followed" : "fw.unfollowed").replace("{name}", name));
      onChange?.(r.data.following ? 1 : -1);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const Icon = st.following ? UserCheck : UserPlus;
  return (
    <button onClick={toggle} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} data-testid="follow-account-btn"
      className={`flex items-center gap-2 rounded-full px-5 py-2 text-sm font-semibold transition-colors ${st.following ? "border border-[#22e3a1]/50 text-[#22e3a1] bg-[#22e3a1]/10 hover:border-rose-400/50 hover:text-rose-300 hover:bg-rose-500/10" : "cx-btn"}`}>
      <Icon className="w-4 h-4" />{st.following ? (hover ? t("fw.unfollow") : t("fw.following")) : t("fw.follow")}
    </button>
  );
};
